<template>
    <div class="select-wrapper" v-if="true !== disabled">
<!--        <div class="select&#45;&#45;title pb-1 pr-1">{{ $t('base.grooves') }}</div>-->
        <div class="select-field">
            <select
                class="product--base-info"
                :class="{ 'is--disabled': disabled }"
                :disabled="disabled"
                v-model="value"
                @change="change"
            >
                <option
                    v-for="item in collection"
                    :class="{ selected: value === item }"
                    :selected="value === item"
                    :value="item"
                >
                    {{ item.label }}
                </option>
            </select>
        </div>
    </div>
</template>

<script>
    import EventBus from "../../event-bus";
    import { gtag_event } from "../../gtag";

    export default {
        data() {
            return {
                label: App.configuration.variants.grooves.label,
                collection: App.configuration.variants.grooves.elements
            };
        },

        props: {
            value: Object,
            disabled: Boolean,
        },

        methods: {
            change() {
                switch (this.value.value) {
                    case 1:
                        gtag_event('Button Motivsockel Nut', 1);
                        break;

                    case 2:
                        gtag_event('Button Motivsockel 2 Nuten', 2);
                        break;
                }

                this.$emit("input", this.value);
                EventBus.$emit("groovesChanged", this.value);
            },

            colorChanged(item) {
                if ("none" !== item.class) {
                    return;
                }
                if ("cake-topper" !== item.class) {
                    return;
                }

                this.value = this.collection[0];
                this.change();
            }
        },

        mounted() {
            EventBus.$on("colorChanged", this.colorChanged);
        },

        beforeDestroy() {
            EventBus.$off("colorChanged", this.colorChanged);
        }
    };
</script>

<style scoped lang="scss">
    @import "../../assets/scss/components/base";
</style>



// WEBPACK FOOTER //
// src/components/Base/Grooves.vue